import { useDispatch, useSelector } from 'react-redux';
import { 
    selectCurrentStepIndex as selectTrackClaimStepIndex,
    selectCurrentSubstepIndex as selectTrackClaimSubstepIndex,
    selectTrackClaimFlowType,
    setCurrentStepIndex,
    setCurrentSubstepIndex,
    setTrackClaimFlowType 
} from '../redux/features/trackClaimFlowSlice';

export const TRACK_CLAIM_CPR_CLAIM_NUMBER = "TRACK_CLAIM_CPR_CLAIM_NUMBER";
export const TRACK_CLAIM_LOGIN_OTP = "TRACK_CLAIM_LOGIN_OTP";
export const TRACK_CLAIM_DETAILS = "TRACK_CLAIM_DETAILS";

export const TRACK_CLAIM_LOGGED_IN = "TRACK_CLAIM_LOGGED_IN";
export const TRACK_CLAIM_LOGGED_OUT = "TRACK_CLAIM_LOGGED_OUT";

const trackClaimFlowLoggedOut = [
    {
        name: TRACK_CLAIM_CPR_CLAIM_NUMBER,
        substeps: [TRACK_CLAIM_CPR_CLAIM_NUMBER]
    },
    {
        name: TRACK_CLAIM_DETAILS,
        substeps: [TRACK_CLAIM_DETAILS]
    }
];

const trackClaimFlowLoggedIn = [
    {
        name: TRACK_CLAIM_CPR_CLAIM_NUMBER,
        substeps: [TRACK_CLAIM_CPR_CLAIM_NUMBER]
    },
    {
        name: TRACK_CLAIM_DETAILS,
        substeps: [TRACK_CLAIM_DETAILS]
    }
];

export const track_claim_flow = {
    [TRACK_CLAIM_LOGGED_OUT]: trackClaimFlowLoggedOut,
    [TRACK_CLAIM_LOGGED_IN]: trackClaimFlowLoggedIn
};

const useTrackClaimFlow = () => {
    const dispatch = useDispatch();
    const flowType = useSelector(selectTrackClaimFlowType) || TRACK_CLAIM_LOGGED_OUT;
    const currentStepIndex = useSelector(selectTrackClaimStepIndex);
    const currentSubstepIndex = useSelector(selectTrackClaimSubstepIndex);

    const steps = track_claim_flow[flowType] || [];
    const currentStep = steps[currentStepIndex] || {};
    const currentSubstep = currentStep.substeps ? currentStep.substeps[currentSubstepIndex] : '';

    const handleFlowChange = (type, stepIndex, substepIndex = 0) => {
        dispatch(setTrackClaimFlowType({ type, currentStepIndex: stepIndex, currentSubstepIndex: substepIndex }));
    };

    const handleNextSubstep = () => {
        if (currentStep.substeps && currentSubstepIndex < currentStep.substeps.length - 1) {
            dispatch(setCurrentSubstepIndex(currentSubstepIndex + 1));
        } else if (currentSubstepIndex === currentStep.substeps.length - 1) {
            handleNextStep();
        }
    };

    const handlePrevSubstep = () => {
        if (currentSubstepIndex > 0) {
            dispatch(setCurrentSubstepIndex(currentSubstepIndex - 1));
        } else {
            handlePrevStep();
        }
    };

    const handleNextStep = () => {
        if (currentStepIndex < steps.length - 1) {
            dispatch(setCurrentStepIndex(currentStepIndex + 1));
        }
    };

    const handlePrevStep = () => {
        if (currentStepIndex > 0) {
            const prevStep = steps[currentStepIndex - 1] || {};
            const substepIndex = prevStep?.substeps?.length - 1 || 0;
            dispatch(setCurrentStepIndex(currentStepIndex - 1));
            dispatch(setCurrentSubstepIndex(substepIndex));
        }
    };

    const resetFlow = () => {
        dispatch(setTrackClaimFlowType({ 
            type: TRACK_CLAIM_LOGGED_OUT, 
            currentStepIndex: 0, 
            currentSubstepIndex: 0 
        }));
    };

    return {
        handleFlowChange,
        handleNextSubstep,
        handlePrevSubstep,
        handleNextStep,
        handlePrevStep,
        resetFlow,
        flowType,
        steps,
        currentStep,
        currentStepIndex,
        currentSubstep,
        currentSubstepIndex
    };
};

export default useTrackClaimFlow;
